import React, { useState, useEffect, useCallback } from 'react';
import { updateOrdenesCompra } from '../../api/ordenesCompra';
import { Button, TextField, Box, CircularProgress, Checkbox, Autocomplete } from '@mui/material';
import { updateGanacias } from '../../api/resumenGanancias';
import { getProductosEnInventario } from '../../api/productos';
import { agregarNovedad } from '../../api/misServicios';
import { UseAlert } from '../../components/newAlert/NewAlert';

// interface Data {
//     SrvDl_Novedad: string;
// }

const ReportNove = React.memo(({ servicios, onClose }: any) => {
    const { NewNotification } = UseAlert();
    const [formData, setFormData] = useState(servicios);
    // const [data, setData] = useState<Data>({
    //     SrvDl_Novedad: '',
    // });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        SrvDl_Novedad: '',
    });

    const validate = () => {
        let tempErrors = {
            SrvDl_Novedad: '',
        };
        if (!formData.SrvDl_Novedad) {
            tempErrors.SrvDl_Novedad = 'Este campo no puede estar vacío';
        }
        setErrors(tempErrors);
        return Object.values(tempErrors).every((x) => x === '');
    };

    const handleSubmit = async () => {
        if (!validate()) return;
        setLoading(true);
        try {
            const postData = {
                id: formData.SrvDI_Id,
                detalle: formData.SrvDl_Novedad,
            };
            console.log('Datos a enviar:', postData);
            const result = await agregarNovedad(postData);
            if (result.isOk) {
                NewNotification('Novedad agregada exitosamente', 'success');
                onClose();
            } else {
                NewNotification(result.message || 'Error al agregar novedad', 'error');
            }
            onClose();
        } catch (error) {
            console.error('Error al actualizar las ganancias:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <form>
                <TextField
                    label="Reportar novedades"
                    name="SrvDl_Novedad"
                    value={formData.SrvDl_Novedad}
                    onChange={(e) => setFormData({ ...formData, SrvDl_Novedad: e.target.value })}
                    fullWidth
                    required
                    sx={{ marginBottom: '0.8rem', marginTop: '1rem' }}
                    size="small"
                    error={!!errors.SrvDl_Novedad}
                    helperText={errors.SrvDl_Novedad}
                />
                <Box display="flex" justifyContent="space-between">
                    <Button onClick={handleSubmit} variant="outlined" size="small" disabled={loading}>
                        {loading ? <CircularProgress size={24} /> : 'Agregar Novedad'}
                    </Button>
                    <Button onClick={onClose} variant="outlined" color="error" size="small">
                        Cancelar
                    </Button>
                </Box>
            </form>
        </div>
    );
});

export default ReportNove;